/**
 * Italian (Italy). Scaffolded, not translated — same convention as
 * @equinox/shared. Missing keys fall back to es-MX.
 */

import type { AdminMessages } from './index.js';

export const adminItIT: Partial<AdminMessages> = {};
